import { render, staticRenderFns } from "./select-spu.vue?vue&type=template&id=104b1512&scoped=true&"
import script from "./select-spu.vue?vue&type=script&lang=js&"
export * from "./select-spu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104b1512",
  null
  
)

export default component.exports